import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthTrackingService } from '@core/services';

@Injectable()
export class ChangePasswordGuard implements CanActivate {

  constructor(
    private router: Router,
    private authTrackingService: AuthTrackingService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authTrackingService.isSocial() === false) {
      // user is a local account and can access the change password component
      return true;
    }

    this.router.navigate(['/account/settings/d/avatar']);
    return false;
  }
}
